import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

import FullPageLoading from '../FullPageLoading';

const RegistrationProvider = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const { pathname } = useLocation();

  if (pathname.toLocaleLowerCase().includes('/registration')) {
    const Registration = React.lazy(() => import('./Registration'));
    const BrazilRegistration = React.lazy(() => import('./br'));
    const ItalyRegistration = React.lazy(() => import('./it'));

    const renderLocalizedRegistration = () => {
      switch (pathname.toLocaleLowerCase()) {
        case '/registration/br':
        case '/br/registration':
          return <BrazilRegistration />;
        case '/it/registration':
          return <ItalyRegistration />;
        default:
          return <Registration />;
      }
    };

    return (
      <Suspense fallback={<FullPageLoading />}>
        {renderLocalizedRegistration()}
      </Suspense>
    );
  }

  return children;
};

export default RegistrationProvider;
